export const STANDARD_DATE_FORMAT = 'DD/MM/YYYY'
